// extracted by mini-css-extract-plugin
export default {"caption":"zrSr1vrAAa5aFtt1PfkU","subCaption":"R0YmXg4U3NzvOTZsHxmf"};